import posthog from 'posthog-js';
import type { CookieConsentConfig } from 'vanilla-cookieconsent';

export const cookieConsentConfig: CookieConsentConfig = {
	categories: {
		necessary: {
			enabled: true,
			readOnly: true
		},
		analytics: {
			enabled: false,
			readOnly: false,
			autoClear: {
				cookies: [{ name: /^ph_/ }]
			}
		}
	},

	onFirstConsent: ({ cookie }) => {
		if (cookie.categories.includes('analytics')) {
			posthog.opt_in_capturing();
		}
	},

	onConsent: ({ cookie }) => {
		if (cookie.categories.includes('analytics')) {
			posthog.opt_in_capturing();
		}
	},

	onChange: ({ cookie, changedCategories }) => {
		if (changedCategories.includes('analytics')) {
			if (cookie.categories.includes('analytics')) {
				posthog.opt_in_capturing();
			} else {
				posthog.opt_out_capturing();
			}
		}
	},

	language: {
		default: 'fr',
		translations: {
			fr: {
				consentModal: {
					title: 'Nous utilisons des cookies',
					description:
						'Nous utilisons des cookies analytiques pour comprendre comment vous utilisez notre application et améliorer votre expérience. Vous pouvez choisir les cookies que vous souhaitez autoriser.',
					acceptAllBtn: 'Tout accepter',
					acceptNecessaryBtn: 'Refuser',
					showPreferencesBtn: 'Gérer les préférences'
				},
				preferencesModal: {
					title: 'Préférences de cookies',
					acceptAllBtn: 'Tout accepter',
					acceptNecessaryBtn: 'Refuser tout',
					savePreferencesBtn: 'Enregistrer les préférences',
					sections: [
						{
							title: 'Cookies strictement nécessaires',
							description:
								"Ces cookies sont essentiels au fonctionnement de l'application. Ils ne peuvent pas être désactivés.",
							linkedCategory: 'necessary'
						},
						{
							title: 'Cookies analytiques',
							description:
								"Ces cookies nous permettent de mesurer l'audience et de comprendre comment les utilisateurs interagissent avec l'application afin de l'améliorer.",
							linkedCategory: 'analytics'
						}
					]
				}
			}
		}
	}
};
